import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { ItemContainer, ItemLabel, ItemValue } from ".";
import {
  formatNumber,
  getListingDisplayDate,
  getTranslatedReasonText,
} from "../../../../helpers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { LinkSpan } from "../../../form/FormElements";
import { useHistory } from "react-router";
import PartsFormPopup from "../../../../../components/Inventory/Parts/PartsFormPopup";
import { postApi } from "../../../../../api/getUser";
import Snackbar from "../../../Snackbar";

const UsageRightPanel = ({ rowData }) => {
  const history = useHistory();
  const { t } = useTranslation("common");
  const { currency } = useSelector((state) => state.units);
  const { roleId } = useSelector((state) => state.user);
  const allVehicles = useSelector((state) => state.vehicles.list);

  const {
    transaction_date,
    reason,
    parts_batch_id,
    batch_id,
    new_qty,
    service_task_name,
    vendor,
    purchase_cost_per_unit,
    purchase_total_cost,
    service_id,
    wo_id,
    qty_changed,
    veh_id,
    notes,
  } = rowData;

  const reasonText = getTranslatedReasonText(reason, t);

  //states for parts form(to view batch details)
  const [showPartsForm, setShowPartsForm] = useState(false);
  const [editBatchRowData, setEditBatchRowData] = useState(null);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  //Check if vehicle exists since manager may not have access to some vehicles
  //in which case we need to hide view service/wo details
  const vehicleExists = allVehicles.find((v) => v.veh_id === veh_id);
  console.log("vehicleExists", vehicleExists);

  useEffect(() => {
    if (snackbarMsg) {
      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
        setSnackbarMsg("");
      }, 5000);
    }
  }, [snackbarMsg]);

  const handleView = async () => {
    // if (reason === 1 || reason === 6) {
    if (wo_id) {
      //View WO
      const route = "/workorders/addnew";
      const screen = "workorders";
      const data = { rowData };

      //const { route, screen, data } = editData;
      //const type = "edit";
      history.push(route, {
        type: "edit",
        route,
        screen,
        data,
        mode: "from-usage",
      });
      return;
    }

    if (service_id) {
      //View service
      const route = "/services/services/addnew";
      const screen = "services";
      const data = { rowData };

      //const { route, screen, data } = editData;
      //const type = "edit";
      history.push(route, {
        type: "edit",
        route,
        screen,
        data,
        mode: "from-usage",
      });
      //return;
    }
    // }
    if (!service_id && !wo_id) {
      //View batch
      const batchApiRes = await postApi(
        { parts_batch_id, querystring: "fetch_single_batch" },
        "inventory"
      );
      if (batchApiRes.success) {
        const { inventory_data } = batchApiRes;
        console.log("inventory_data", inventory_data);
        if (inventory_data.length > 0) {
          const singleBatchData = inventory_data[0];
          setEditBatchRowData(singleBatchData);
          setShowPartsForm(true);
        }
        // if (inventory_data?.length > 0) {
        //   temp = inventory_data.map((row) => {
        //     let customFields = [];
        //     const { custom_fields } = row;
        //     //Custom Fields
        //     if (custom_fields) {
        //       const customFieldsArr = JSON.parse(custom_fields);
        //       customFields = customFieldsArr.map((f, i) => ({
        //         title: f.key,
        //         author: f.value,
        //         id: Date.now() + i,
        //       }));
        //     }
        //     return { ...row, viewMore: false, customFields };
        //   });
        // }
      }
    }
  };

  return (
    <>
      {showPartsForm && (
        <PartsFormPopup
          showPopup={showPartsForm}
          setShowPopup={setShowPartsForm}
          mode={"edit-batch"}
          rowData={editBatchRowData}
          setSnackbarMsg={setSnackbarMsg}
          from={"from-usage"}
        />
      )}
      {showSnackbar && (
        <Snackbar
          showSnackbar={showSnackbar}
          setShowSnackbar={setShowSnackbar}
          message={snackbarMsg}
          setMessage={setSnackbarMsg}
          //snackbarType={snackbarData.type}
        />
      )}
      <Row>
        <Col>
          <ItemContainer>
            <ItemLabel>{t("date_tv")}</ItemLabel>
            <ItemValue>{getListingDisplayDate(transaction_date)}</ItemValue>
          </ItemContainer>
        </Col>
        <Col>
          <ItemContainer>
            <ItemLabel>{t("reason_for_change")}</ItemLabel>
            <ItemValue>{reasonText}</ItemValue>
          </ItemContainer>
        </Col>
      </Row>
      <Row>
        <Col>
          <ItemContainer>
            <ItemLabel>{t("qty_change")}</ItemLabel>
            <ItemValue>{formatNumber(qty_changed)}</ItemValue>
          </ItemContainer>
        </Col>
        <Col>
          <ItemContainer>
            <ItemLabel>{t("batch_id")}</ItemLabel>
            <ItemValue>{batch_id}</ItemValue>
          </ItemContainer>
        </Col>
      </Row>
      <Row>
        <Col>
          <ItemContainer>
            <ItemLabel>{t("balance_qty")}</ItemLabel>
            <ItemValue>{formatNumber(new_qty)}</ItemValue>
          </ItemContainer>
        </Col>
        <Col>
          <>
            {reason === 0 && (
              <ItemContainer>
                <ItemLabel>{t("cost_per_unit")}</ItemLabel>
                <ItemValue>{`${formatNumber(
                  purchase_cost_per_unit,
                  3
                )} ${currency}`}</ItemValue>
              </ItemContainer>
            )}
            {(service_id || wo_id) && vehicleExists && (
              <ItemContainer>
                <ItemLabel>{t("vehicle")}</ItemLabel>
                <ItemValue>{vehicleExists?.name}</ItemValue>
              </ItemContainer>
            )}
          </>
        </Col>
      </Row>
      {reason === 0 && (
        <Row>
          <Col>
            <ItemContainer>
              <ItemLabel>{t("purchase_cost")}</ItemLabel>
              <ItemValue>{`${formatNumber(
                purchase_total_cost,
                2
              )} ${currency}`}</ItemValue>
            </ItemContainer>
          </Col>
          {vendor && (
            <Col>
              <ItemContainer>
                <ItemLabel>{t("vendor")}</ItemLabel>
                <ItemValue>{vendor}</ItemValue>
              </ItemContainer>
            </Col>
          )}
        </Row>
      )}

      {(service_id || wo_id) && (
        <Row>
          <Col>
            <ItemContainer>
              <ItemLabel>{t("service_task_name")}</ItemLabel>
              <ItemValue>{service_task_name}</ItemValue>
            </ItemContainer>
          </Col>
          {/* <Col>
                <ItemContainer>
                  <ItemLabel>
                    {wo_id ? t("technician") : t("serviced_by")}
                  </ItemLabel>
                  <ItemValue>
                    {wo_id ? technician_name : serviced_by_name}
                  </ItemValue>
                </ItemContainer>
              </Col> */}
        </Row>
      )}

      {notes && (
        <Row>
          <Col>
            <ItemContainer>
              <ItemLabel>{t("notes")}</ItemLabel>
              <ItemValue>{notes}</ItemValue>
            </ItemContainer>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <ItemContainer>
            <ItemValue>
              {/* {reason === 0 && (
                <LinkSpan onClick={handleViewBatch}>
                  {t("view_batch_details")}
                </LinkSpan>
              )} */}

              {
                //(reason === 1 || reason === 6) &&
                vehicleExists && wo_id && (
                  <LinkSpan onClick={handleView}>
                    {t("view_wo_details")}
                  </LinkSpan>
                )
              }

              {/* roleId !== 4 -  Dont show service to technicians */}
              {
                //(reason === 1 || reason === 6) &&
                vehicleExists && !wo_id && service_id && roleId !== 4 && (
                  <LinkSpan onClick={handleView}>
                    {t("view_service_details")}
                  </LinkSpan>
                )
              }

              {
                //reason != 1 &&
                !service_id && !wo_id && (
                  <LinkSpan onClick={handleView}>
                    {t("view_batch_details")}
                  </LinkSpan>
                )
              }

              {/* <LinkSpan onClick={handleView}>
                {reason === 1 && wo_id
                  ? t("view_wo_details")
                  : reason === 1 && service_id
                  ? t("view_service_details")
                  : t("view_batch_details")}
              </LinkSpan> */}
            </ItemValue>
          </ItemContainer>
        </Col>
      </Row>
    </>
  );
};

export default UsageRightPanel;
